import Mock from 'mockjs'

const {page, save} = require('../util');
let {itemDefs, itemDefSets, items} = require('./data');
const qs = require('qs');

Mock.mock('/data-item/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(items, bodyObject);
    bodyObject.total = items.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/data-item/save', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    let index = save(bodyObject, items);
    return {
        code: 200,
        body: items[index]
    }
});

Mock.mock('/data-item-def/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(itemDefs, bodyObject);
    bodyObject.total = itemDefs.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/data-item-def/save', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    let index = save(bodyObject, itemDefs);
    return {
        code: 200,
        body: itemDefs[index]
    }
});

Mock.mock('/data-item-def-set/fineAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(itemDefSets, bodyObject);
    bodyObject.total = itemDefSets.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/data-item-def-set/save', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    let index = save(bodyObject, itemDefSets);
    return {
        code: 200,
        body: itemDefSets[index]
    }
});
